const actions = {
  /**
   * Fetch the balance.
   *
   * @param commit
   * @param $http
   * @returns {Promise<void>}
   */
  async fetchBalance({ commit, rootState: { $http } }) {
    const { data } = await $http.get('/user/balance');

    commit('setBalance', data.balance);
  },

  /**
   * Buy credits.
   *
   * @param commit
   * @param $http
   * @param form
   * @returns {Promise<object>}
   */
  async buy({ commit, rootState: { $http } }, form) {
    const { data } = await $http.post('/payment', form);

    commit('setLastBuy', {
      order: data.order,
      slipUrl: data.boletoUrl || null,
    });
  },

  async registerIntentCreate({ commit, rootState: { $http } }) {
    const { data } = await $http.post('/register/intent/');

    commit('setIntent', data);
  },

  async subscribeIntentCreate({ commit, rootState: { $http } }, planId) {
    const { data } = await $http.post('/payment/intent/', { planId });

    commit('setIntent', data);
  },

  async paymentMethodIntentCreate({ commit, rootState: { $http } }) {
    const { data } = await $http.post('/payment/method/intent');

    commit('setIntent', data);
  },

  async subscribeIntentCheck({ rootState: { $http } }, id) {
    await $http.patch(`/payment/intent/${id}`);
  },

  async autoRecharge({ rootState: { $http } }, value) {
    await $http.patch('/payment/auto-recharge', { auto_recharge_value: value });
  },

  async cancel({ rootState: { $http } }) {
    await $http.patch('/payment/cancel');
  },

  async plans({ commit, rootState: { $http } }) {
    const { data } = await $http.get('/plans');

    commit('setPlans', data);
  },

  async registerPlans({ commit, rootState: { $http } }, { group }) {
    const { data } = await $http.get(`/register/plans?group=${group}`);

    commit('setPlans', data);
  },

  async plan({ commit, rootState: { $http } }, id) {
    const { data } = await $http.get(`/plans/${id}`);

    commit('setPlan', data);
  },

  async paymentMethods({ commit, rootState: { $http } }) {
    const { data } = await $http.get('/payment/method');

    commit('setPaymentMethods', data);
  },

  async pay({ rootState: { $http } }, { creditCard, planId }) {
    const { data } = await $http.patch('/payment/pay/', { planId, creditCard });

    return data;
  },

  async payRecharge({ rootState: { $http } }, { creditCard, price }) {
    const { data } = await $http.patch('/payment/recharge/pay/', { creditCard, price });

    return data;
  },

  async detachPaymentMethod({ rootState: { $http } }, id) {
    await $http.delete(`/payment/method/${id}`);
  },
};

export default actions;
